import Collection from 'lib/client/collections/collection'

class ServiceAreas extends Collection{
    fetch(options){
        return this.axios.get(`organizations/${this.props.currentOrganization.id}/service-areas`, options);
    }

    create(options){
        return this.axios.post(`organizations/${this.props.currentOrganization.id}/service-areas`, options);
    }

    update(options){
        return this.axios.put(`organizations/${this.props.currentOrganization.id}/service-areas/${options.id}`, options);
    }
    
    destroy(options){
        return this.axios.delete(`organizations/${this.props.currentOrganization.id}/service-areas/${options.id}`);
    }
}

export default ServiceAreas;